import {
  getKioskSurveyApi,
  getKitchenSurveyApi,
  getKitchenDiningSurveyApi,
} from "../../services/surveyService";
import { setLoading, setError, setSurveyData } from "./mySurveysSlice";

export const fetchMySurveys = (canteenType, canteenId, reportingDate) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    dispatch(setError(null));

    let response;
    // 1 = kiosk, 2 = kitchen, 3 = kitchen cum dining
    if (String(canteenType) === "1") {
      response = await getKioskSurveyApi(canteenId, reportingDate);
    } else if (String(canteenType) === "2") {
      response = await getKitchenSurveyApi(canteenId, reportingDate);
    } else if (String(canteenType) === "3") {
      response = await getKitchenDiningSurveyApi(canteenId, reportingDate);
    } else {
      throw new Error("Invalid canteen type");
    }

    dispatch(setSurveyData(response?.data || response));
    return response;
  } catch (error) {
    const errorMessage = error?.message || "Failed to fetch survey data";
    dispatch(setError(errorMessage));
    throw error;
  } finally {
    dispatch(setLoading(false));
  }
};
